const getters = {
    userBtnActiveNum: state => state.settings.userBtnActiveNum,
}
export default getters
